import type { AbExperiment } from "@/utils/abTesting";

export const HOME_TRIAL_FLOW_EXPERIMENT: AbExperiment = {
  id: "home_trial_flow_v2",
  cookieName: "sr_ab_home_trial_flow_v2",
  cookieMaxAgeSeconds: 60 * 60 * 24 * 60,
  variants: [
    { key: "a", weight: 50 },
    { key: "b", weight: 50 },
  ],
};
